"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pollPlugin = {
  init: function init(editor) {
    editor.ui.addButton('Poll', {
      label: 'Poll',
      command: 'poll',
      icon: 'poll'
    });
    editor.addCommand('poll', {
      exec: function exec() {
        editor.fire('pollButtonClicked');
      }
    });
  }
};
var _default = pollPlugin;
exports.default = _default;